module.exports = __webpack_public_path__ + "static/img/equ1.a12939bf.png";